export const navBarHeight = 48
